var exports = {
  "q": "xaf9ae18d--b1d05c--layer",
};

module.exports = exports;
